import {Button, FileUpload as ChakraFileUpload} from '@chakra-ui/react'
import {LuUpload} from 'react-icons/lu'
import {useTranslate} from '@tolgee/react'

type Props = {
  onFileSelect: (file: File | null) => void
  label?: string
}

export function FileUpload({onFileSelect, label}: Props) {
  const {t} = useTranslate('common')

  return (
    <ChakraFileUpload.Root
      accept="image/png,image/jpeg,image/webp,image/svg+xml"
      maxFiles={1}
      onFileChange={details => onFileSelect(details.acceptedFiles[0] ?? null)}
    >
      <ChakraFileUpload.HiddenInput style={{display: 'none'}} />
      <ChakraFileUpload.Trigger asChild>
        <Button variant="outline" size="sm" bg="bg">
          <LuUpload /> {label || t('upload_file')}
        </Button>
      </ChakraFileUpload.Trigger>
      <ChakraFileUpload.List />
    </ChakraFileUpload.Root>
  )
}
